function sortBySoldClosed(arr) {
  if (!Array.isArray(arr)) return [];

  return arr.sort((a, b) => {
    const score = (obj) => {
      if (obj.is_sold === 0 && obj.is_closed === 0) return 0; // highest priority
      if (obj.is_sold === 1) return 1; // second
      if (obj.is_closed === 1) return 2; // last
      return 3; // fallback
    };

    return score(a) - score(b);
  });
}

export default sortBySoldClosed;
